export enum CardSuitShort {
    CLUBS = 'c',
    SPADES = 's',
    HEARTS = 'h',
    DIAMONDS = 'd',
}
